import L from 'leaflet';
import util from '../util';
import map_base from './map_base';
;
/**
 * 土砂災害地図表示用クラス
 */
export default class map_dosha_base extends map_base {
    _meshLayer = null;
    _cityLayer = null;
    _soilWaterIndexTable;
    /**
     * コンストラクタ
     */
    constructor(mapElement, mapPos) {
        super(mapElement, mapPos);
        createDosha1ktable();
        this.setSoilWaterIndexStandardTable();
        this.Initilize();
    }
    /**
     * 土砂災害メッシュ情報の更新有無をチェックし、
     * 更新されていた場合に、地図レイヤを書き換える
     */
    checkUpdateLayer() {
        createDosha1ktable();
        this.setMeshLayer();
    }
    /**
     * 地図にメッシュレイヤーを設定します
     */
    setMeshLayer() {
        //  表示中のメッシュレイヤーが存在する場合は削除
        if (this._meshLayer) {
            this.Map.removeLayer(this._meshLayer);
        }
        if (this._cityLayer) {
            this.Map.removeLayer(this._cityLayer);
        }
        //  メッシュレイヤー生成
        this._meshLayer = this.createLayer();
        this._cityLayer = L.tileLayer("./city_tiles/" + "{z}/{x}/{y}.png", { opacity: 0.6 });
        //  地図にメッシュレイヤー追加
        this.Map.addLayer(this._meshLayer);
        this.Map.addLayer(this._cityLayer);
    }
    /**
     * メッシュのスタイル情報取得
     * @param feature
     */
    getMeshStyle(mesh) {
        //除外格子フラグ
        let isExclusion = this._soilWaterIndexTable && this._soilWaterIndexTable[mesh].isExclusion;
        return getDoshaMeshStyles(mesh, isExclusion);
    }
    _preSelect = null;
    _preMesh = "";
    /**
     * 選択メッシュの強調
     * @param meshcode
     */
    selectMesh(meshcode) {
        if (meshcode) {
            let bounds = util.meshToLatLngBounds(meshcode);
            if (this._preSelect) {
                this._preSelect.remove();
            }
            let curRec = L.rectangle(bounds, dosya_1kmesh_env.selectMeshStyle).addTo(this.Map);
            this._preSelect = curRec;
            this._preMesh = meshcode;
        }
    }
    /**
     * 選択メッシュの再描画
     */
    reflash() {
        if (this._preMesh) {
            this.selectMesh(this._preMesh);
        }
    }
    /**
     * 土壌雨量指数基準(cp,kp)テーブルをプロパティにセットする
     */
    setSoilWaterIndexStandardTable() {
        this._soilWaterIndexTable = getSoilWaterIndexStandardTable();
    }
}
